import moment from 'moment';

export function calculateDifferenceBetweenDates(endDate) {
  const dateCalculate = moment(endDate);
  const now = moment();
  const differences = dateCalculate.diff(now);
  const days = Math.floor(differences / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (differences % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((differences % (1000 * 60 * 60)) / (1000 * 60));

  if (days > 1) {
    return `${days} días`;
  }
  if (days === 1) {
    return `${days} día`;
  }
  if (days < 1 && hours > 0 && hours !== 1) {
    return `${hours} horas`;
  }
  if (days < 1 && hours > 0 && hours === 1) {
    return `${hours} hora`;
  }
  if (days <= 0 && hours <= 0 && minutes > 0) {
    return `${minutes} minutos`;
  }

  return 'Tiempo expirado';
}

export function hasDaysLeft(endDate) {
  const dateCalculate = moment(endDate);
  const now = moment();
  const differences = dateCalculate.diff(now);
  const days = Math.floor(differences / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (differences % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((differences % (1000 * 60 * 60)) / (1000 * 60));
  if (days > 0) {
    return true;
  }
  if (days <= 0 && hours > 0) {
    return true;
  }
  if (days <= 0 && hours <= 0 && minutes > 0) {
    return true;
  }
  return false;
}
